import { MouseEvent as ReactMouseEvent, SyntheticEvent } from "react"

/**
 * Wraps a React event handler to prevent default behavior and optionally stop propagation
 */
export const preventDefaultClick = <T extends SyntheticEvent = ReactMouseEvent>(
  handler?: (event: T) => void,
  options: {
    stopPropagation?: boolean
    preventDefault?: boolean
  } = { preventDefault: true, stopPropagation: false },
) => {
  return (event: T) => {
    if (options.preventDefault) {
      event.preventDefault()
    }
    if (options.stopPropagation) {
      event.stopPropagation()
    }
    handler?.(event)
  }
}

/**
 * Specifically for React mouse click events - prevents default and optionally stops propagation
 */
export const preventClick = <T extends HTMLElement = HTMLElement>(
  handler?: (event: ReactMouseEvent<T>) => void,
  stopPropagation = false,
) => {
  return preventDefaultClick(handler, {
    preventDefault: true,
    stopPropagation,
  })
}
